import { render, staticRenderFns } from "./_base-checkbox.vue?vue&type=template&id=3ed2dda9&scoped=true&"
import script from "./_base-checkbox.vue?vue&type=script&lang=js&"
export * from "./_base-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./_base-checkbox.vue?vue&type=style&index=0&id=3ed2dda9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed2dda9",
  null
  
)

export default component.exports